/**
 * Created by Christof Sander on 27.01.2017.
 */

const utils = require('frontend-controller/lib/utils');
var store   = require('frontend-controller/lib/store');

module.exports = {
	config: {
		environmentDependent: true,
		columnTransitions: {
			slide: {
				minLevel:   3,
				duration:   0.5,
				ease:       Cubic.easeInOut
			},
			opacity: {
				minLevel:   0,
				duration:   0.5,
				ease:       Cubic.easeInOut
			}
		},
		additionalStyles: [
			'columnMenu',
			'backButton',
			'blackNavButton',
			'whiteNavButton',
			'gridBorder',
			'endlessScroll',
			'windowPadding',
			'maxWidthRegulation',
			'fullHeight',
			'coloredBackground'
		]
	},

	model: {
		activeRoute: '',
		additionalStyles: [],
		additionalStylesChanged: false,
		styleChanged: false,
		routes: {},
		columns: [],
		columnUpdates: 0,
		gridDependentRegister: [],
		refreshNextMove: false,
		endlessScrollInEffect: false,

		states: {}
	},

	events: {
		navigation: {
			type: 'click',
			action: function(event){
				event.stopImmediatePropagation();
				var $realTarget;
				var $target = $(event.target);

				if(($realTarget = $target.closest('.templates_button_button, .mobile_button_button')).length > 0){
					var linkData, $targetComponent;
					if(($targetComponent = $realTarget.closest('[data-component-index]')).length > 0){
						if((linkData = getComponent($targetComponent).model.buttonAction)){
							if(linkData.indexOf('@') === 0){
								event.data.component.model.headPanel.to(linkData.substring(1), undefined, true);
							}
							else {
								window.open(linkData);
							}
						}
						else if((linkData = getComponent($targetComponent).model.buttonLink.data)){
							if(Array.isArray(linkData)) linkData = linkData[0].split('_');
							event.data.component.linkTo(linkData);
						}
					}
				}
				else if(($realTarget = $target.closest('.templates_headPanel_breadCrumbs > li')).length > 0){
					var route;
					if((route = $realTarget.data('route'))){
						var routeParts = route.split('#');
						if(routeParts.length > 1){
							if(routeParts.length == 2){
								event.data.component.to(routeParts[0], undefined, routeParts[1]);
							}
							else {
								console.error('invalid route parts detected');
							}
						}
						else {
							event.data.component.to(route);
						}
					}
				}
				else if(($realTarget = $target.closest('.linkTo')).length > 0){
					var linkData;
					if((linkData = $realTarget.data('buttonAction'))){
						if(linkData.indexOf('@') === 0){
							event.data.component.model.headPanel.to(linkData.substring(1), undefined, true);
						}
						else {
							window.open(linkData);
						}
					}
				}
				else if(($realTarget = $target.closest('.templates_commercialProperties_object')).length > 0){
					// navigate to commercial objects detail page
					var objectComponent, detailsRoute;
					if(
						(objectComponent = getComponent($realTarget))
						&&
						(detailsRoute = objectComponent.model.linkToDetails)
						&&
						detailsRoute.data
					){
						event.data.component.linkTo(detailsRoute.data);
					}
				}
				else if(($realTarget = $target.closest('.templates_project_objectList_objectList .list table tr')).length > 0){
					// navigate to commercial objects detail page
					var routeID;
					if(
						(routeID = $realTarget.data('routeId'))
					){
						event.data.component.linkTo(routeID);
					}
				}
				else if(($realTarget = $target.closest('.templates_window_segment')).length > 0){
					var linkData;
					// TODO: update to FEC-v2 and implement routeComponentPicker.result.route etc. instead of routeComponentPicker.data!
					if((linkData = getComponent($realTarget).model.link.data)){
						if(Array.isArray(linkData)) linkData = linkData[0].split('_');
						event.data.component.linkTo(linkData);
					}
				}
			}
		},

		scroll: {
			type: 'mousewheel DOMMouseScroll',
			action: function(event){
				if(!event.data.component.model.endlessScrollInEffect) {
					if (event.originalEvent.wheelDelta > 0 || event.originalEvent.detail < 0) {
						event.data.component.scrollUp();
					}
					else {
						event.data.component.scrollDown();
					}
				}
			}
		}
	},

	methods: {



		///////////////////////////////////
		/// BASE FUNCTIONALITY
		///////////////////////////////////

		/**
		 * this function has to return true if the environment dependent refresh should be performed.
		 *
		 * @param   activeEnvironment               {} - active environment
		 * @param   newEnvironment                  {} - new environment
		 * @param   serverKnownEnvironment          {} - environment known by the server
		 * @param   initialExecution                boolean - is this the initial execution
		 * @param   externalDrivenCall              boolean - e.g., browser resize -> true, ibt-grid-style-change -> false
		 * @param   environmentUpdateByParent       boolean - has a parent of mine decided to refresh and already updated by own activeEnvironment
		 * @returns boolean
		 */
		environmentRefreshNecessary: function(activeEnvironment, newEnvironment, serverKnownEnvironment, initialExecution, externalDrivenCall, environmentUpdateByParent){
			this.model.styleChanged = activeEnvironment.style != newEnvironment.style;

			// be sure to scroll to the right window after (e.g. a resize) an external driven environmental refresh
			if(externalDrivenCall) this.model.refreshNextMove = true;

			// html refresh is unnecessary
			return false;
		},

		/**
		 * this function will be used to sanitize the built tree on dynamic loaded columns.
		 * NOTE: used to remove not needed components like the master layout, ...
		 *
		 * @param   context     {} - action-context of the load action
		 */
		postBuildSanitize: function(context){
			// is this a loader action?
			if(context.action.source && context.action.source.load && context.action.source.load.componentTree && context.action.source.load.routePath){
				// remove unnecessary overhead from tree
				var destroyMasterAboveLayoutIndex;
				if(!this.model.routes[context.action.source.load.routePath]) this.model.routes[context.action.source.load.routePath] = {};
				this.model.routes[context.action.source.load.routePath].routeModel = context.action.source.load.componentTree.model;
				this.model.routes[context.action.source.load.routePath].routeModel.breadCrumbs = (context.action.source.load.componentTree.commonRouteInfo || {}).breadCrumbs;
				this.model.routes[context.action.source.load.routePath].routeModel.routeConfig = (context.action.source.load.componentTree.config || {}).routeConfig;
				context.action.source.load.componentTree.children[context.action.source.load.componentTree.childLayoutIndex].find('layouts_column_column', function(component){
					// splice component connection to its parent
					component.destroy(true, true);

					// remember master layout index before the component will be overwritten within action context
					destroyMasterAboveLayoutIndex = context.action.source.load.componentTree.children[context.action.source.load.componentTree.childLayoutIndex].componentIndex;

					// save new component data as action context
					context.action.source.load.component = component;
					context.action.source.load.component.replaceParentBy(context.component);
					context.action.source.load.component.model.properties.route     	= context.action.source.load.componentTree.path;
					context.action.source.load.component.model.properties.routeID   	= context.action.source.load.componentTree.routeID;
					context.action.source.load.component.model.properties.routeConfig 	= (context.action.source.load.componentTree.config || {}).routeConfig || {};
					context.action.source.load.component.model.properties.active    	= false;
					context.action.source.load.component.model.properties.actual    	= false;
					delete context.action.source.load.componentTree;
					delete context.action.source.load.routePath;
					return 'break';
				});

				// destroy unnecessary overhead
				if(destroyMasterAboveLayoutIndex) getComponent(destroyMasterAboveLayoutIndex).destroy();
			}
		},

		/**
		 * this function returns the column component identified by route.
		 *
		 * @param   route       string - wanted route or wanted route id or undefined.
		 *                      NOTE: if this parameter is undefined the actual column will be returned.
		 * @return  Component
		 */
		getColumn: function(route){
			if(!route) route = this.model.activeRoute;
			if(route && this.model.routes[route] && this.model.routes[route].columnComponent){
				return this.model.routes[route].columnComponent;
			}
			return false;
		},

		/**
		 * this function is used to add a column to the grid.
		 *
		 * @param columnComponent       Component - new column-component
		 * @param loadAnchor            string - anchor used during the load process
		 * @param routeModel            {} - optional - model of route which can be needed to set the right route title or so
		 */
		addColumn: function(columnComponent, loadAnchor, routeModel){
			var route   = columnComponent.model.properties.route;
			var mergeBase;

			if(!(mergeBase = this.model.routes[route]) || !this.model.routes[route].initialized){
				var routeID         = columnComponent.model.properties.routeID;
				var initAnchor      = columnComponent.model.properties.anchor;
				var parts           = route.split('/');
				var nrOfRouteParts  = parts.length;
				var routeParts      = [];
				var breadCrumbs = [];
				var partIndex;
				for(partIndex = 2; partIndex <= nrOfRouteParts; partIndex++){
					routeParts.push(parts.slice(0, partIndex).join('/'));
				}
				var baseRoute = routeParts[1] + '#';
				var path, name;
				for(partIndex = 1; partIndex < routeParts.length; partIndex++){
					parts = routeParts[partIndex].split('/');

					// handle breadcrumb special case for 301 forwarded routes
					if(partIndex == 2){
						parts.shift();
						parts.shift();
						parts.shift();
						path = baseRoute + parts.join('/');
					}
					else {
						path = parts.join('/');
					}

					breadCrumbs.push({
						name:   (((((mergeBase || this.model.routes[route] || {}).routeModel || routeModel || {}).breadCrumbs || [])[partIndex + 1] || {}).model || {}).nameSEO || parts[parts.length - 1],
						path:   path
					});
				}

				this.model.routes[route] = utils.replace(mergeBase || {}, {
					initialized:        true,
					route:              route,
					routeID:            routeID,
					columnComponent:    columnComponent,
					nrOfRouteParts:     nrOfRouteParts - 1,
					routes:             routeParts,
					initAnchor:         initAnchor,
					breadCrumbs:        breadCrumbs
				});
				columnComponent.updateBreadCrumbs(breadCrumbs);
				if(routeModel) this.model.routes[route].routeModel = routeModel;
				this.model.routes[routeID] = this.model.routes[route];
				this.model.columns.push(columnComponent);

				if(!loadAnchor && initAnchor){
					this.changeUrl(route + '#' + initAnchor);
				}
			}
		},

		/**
		 * this function is used to manipulate the browsers' history
		 *
		 * @param route         string - route to add
		 * @param replaceState  boolean - if this flag is set to true the last browsers' history entry will be replaced instead of adding the given route
		 */
		changeUrl: function(route, replaceState){
			// send page view to google analytics
			if(window.trackingGranted) window.ga('send', 'pageview');

			if(replaceState){
				window.history.replaceState({}, '', route);
			}
			else {
				window.history.pushState({}, '', route);
			}
		},

		/**
		 * this function is used to switch the additional grid style.
		 * NOTE: like backButton or columnMenu
		 *
		 * @params  activePanelComponent        Component - this is the active-panel-component (only given by headPanel-calls)
		 */
		switchAdditionalStyle: function(activePanelComponent){
			// init
			var newStyles = [];
			var column, windowProperties, windowComponent;
			delete this.model.windowPaddingInEffect;

			if((column = this.getColumn((this.model.moveToOptions || {}).route))){
				// estimate and perform new style
				if (
					this.activeEnvironment.style === 'desktop'
					&&
					this.model.routes[column.model.properties.route].nrOfRouteParts > 3
				) {
					newStyles.push('backButton');

					if(column.model.properties.route.match(/^\/de\/unternehmen\/referenzen\/galerie/) === null) {
						newStyles.push('fullHeight');
					}
				}
				else if ((this.activeEnvironment.style === 'mobile' && column.model.properties.route !== '/de/startseite') || column.model.properties.columnMenu.nrOfActiveMenuElements > 0) {
					newStyles.push('columnMenu');
				}

				if (
					this.model.routes[column.model.properties.route].nrOfRouteParts > 3
					&&
					column.model.properties.route.match(/^\/de\/unternehmen\/referenzen\/galerie/) === null
				) {
					newStyles.push('coloredBackground');
				}

				var routeName, route, routeConfig
				if(
					(routeName 		= (((column || {}).model || {}).properties || {}).route) &&
					(route 			= (this.model.routes || {})[routeName]) &&
					(routeConfig 	= (route.routeModel|| {}).routeConfig)
				){
					// show gridBorder if necessary
					if(
						this.activeEnvironment.style === 'mobile' &&
						routeConfig.showGridBorder !== false &&
						column.model.properties.route !== '/de/startseite'
					){
						newStyles.push('gridBorder');
					}

					// show coloredBackground if necessary
					if(
						utils.indexOf(newStyles, 'coloredBackground') === -1 &&
						routeConfig.coloredBackground === true
					){
						newStyles.push('coloredBackground');
					}

					// console.log('######## ROUTECONFIG', routeConfig);
					if(routeConfig.maxWidthRegulation === true || (routeConfig.maxWidthRegulation !== false && route.nrOfRouteParts >= 3)){
						newStyles.push('maxWidthRegulation');
					}

					if (routeConfig.windowPadding === true) {
						this.model.windowPaddingInEffect = true;
					}
					else if (routeConfig.windowPadding === false) {
						this.model.windowPaddingInEffect = false;
					}

					if (routeConfig.endlessScroll === true) {
						this.model.endlessScrollInEffect = true;
					} else if (routeConfig.endlessScroll === false) {
						this.model.endlessScrollInEffect = false;
					} else {
						this.model.endlessScrollInEffect = route.nrOfRouteParts >= 3;
					}
				} else {
					if (this.model.routes[column.model.properties.route].nrOfRouteParts >= 3) {
						this.model.endlessScrollInEffect = true;
					} else {
						this.model.endlessScrollInEffect = false;
					}

					// show gridBorder if necessary
					if(
						this.activeEnvironment.style === 'mobile' &&
						column.model.properties.route !== '/de/startseite'
					){
						newStyles.push('gridBorder');
					}

					if((route || {}).nrOfRouteParts >= 3 || (column.model.properties.route.match(/^\/de\/unternehmen\/news/) !== null)){
						newStyles.push('maxWidthRegulation');
					}
				}

				if(this.model.endlessScrollInEffect) {
					newStyles.push('endlessScroll');
					if(this.model.windowPaddingInEffect !== false){
						newStyles.push('windowPadding');
					}
				} else if(this.model.windowPaddingInEffect) {
					newStyles.push('windowPadding');
				}

				if(activePanelComponent){
					if(activePanelComponent.model.color.data === 'white'){
						newStyles.push('blackNavButton');
					}
					else {
						newStyles.push('whiteNavButton');
					}
				}
				else if(
					(windowProperties = (!this.model.moveToOptions ? false : column.getWindowProperties(this.model.moveToOptions.routeComponentID, this.model.moveToOptions.anchor, this.model.moveToOptions.windowIndex))) &&
					(windowComponent = getComponent(windowProperties.windowComponentIndex)) &&
					(
						(
							this.activeEnvironment.style === 'mobile' &&
							windowComponent.model.showOnMobile
						)
						||
						(
							this.activeEnvironment.style === 'desktop' &&
							windowComponent.model.showOnDesktop
						)
					)
					&&
					windowComponent.config.whiteNavButton
				){
					newStyles.push('whiteNavButton');
				}

				if(this.model.additionalStyles == newStyles){
					this.model.additionalStylesChanged = false;
				}
				else {
					this.model.additionalStylesChanged = true;
					this.$.removeClass(this.config.additionalStyles.join(' '));
					this.model.additionalStyles = newStyles;
					this.$.addClass(newStyles.join(' '));
				}

				column.onAdditionalStyleUpdate();
			}
		},

		/**
		 * this function is used to show the right elements within the head-panel and to handle the browsers' history.
		 *
		 * @param column            Component - actual column-component
		 * @param windowProperties  {} - actual target windows' properties
		 * @param morphNecessary    boolean - should the content of the headPanel morph?
		 * @param forceUrlReplace   boolean - should the url history replace be forced?
		 */
		refreshHead: function(column, windowProperties, morphNecessary, forceUrlReplace){
			this.model.styleChanged = false;

			var anchor = '';
			var replaceState = false;
			if(windowProperties.usedAnchor){
				anchor = '#' + windowProperties.usedAnchor;
				replaceState = (windowProperties.triedAnchor && windowProperties.triedAnchor != windowProperties.usedAnchor) || column.model.anchor == windowProperties.usedAnchor;
				replaceState = replaceState && column.model.properties.route == window.location.pathname;
				column.model.anchor = windowProperties.usedAnchor;
			}
			replaceState = replaceState || forceUrlReplace;

			if(morphNecessary || this.model.additionalStylesChanged){
				this.model.headPanel.morph(column, windowProperties.windowRouteComponentID, column.model.properties.route, anchor);
			}

			if(!this.model.browserNavigationInCharge || replaceState){
				this.changeUrl(column.model.properties.route + anchor, replaceState);
			}
		},

		/**
		 * this function is used to register external gridDependent components (e.g., like sliderGallery)
		 * NOTE: these components get an onGridUpdate call each time the grid changes and is ready.
		 *
		 * @param componentIndex    int - componentIndex of component which wants to be informed when the grid will be updated.
		 */
		registerGridDependent: function(componentIndex){
			this.model.gridDependentRegister.push(componentIndex);
		},

		// TODO: DOC!
		changeRouteProperties: function(column){
			var routeModel;
			if(column && column.model.properties.route && this.model.routes[column.model.properties.route] && (routeModel = this.model.routes[column.model.properties.route].routeModel)){
				this.model.master.changeRouteProperties(routeModel);
			}
		},


		///////////////////////////////////
		/// NAVIGATION LOGIC FUNCTIONS
		///////////////////////////////////

		/**
		 * this function starts the navigation transition to a linkID.
		 *
		 * @param linkID        string - linkID <routeID>_<routeComponentID>
		 */
		linkTo: function(linkID){
			var linkParts;
			if((linkParts = (linkID + '').split('_')).length > 0){
				if(linkParts.length > 1){
					this.to(linkParts[0], linkParts[1]);
				}
				else {
					this.to(linkParts[0]);
				}
			}
		},

		/**
		 * this function is used to perform everything necessary to show the content identified by the given parameters.
		 *
		 * @param route                         string - route | routeID of the wanted column
		 * @param routeComponentID              int - optional - routeComponentID of window to show
		 * @param anchor                        string - optional - anchor of window to show
		 * @param windowIndex                   int - optional - window-index of window to show
		 * @param browserNavigationInCharge     boolean - is the browserNavigation (like window.popOffState) in charge or not
		 * @param dragInCharge                  boolean - will the windowWrapper or slider actually be dragged?
		 */
		to: function(route, routeComponentID, anchor, windowIndex, browserNavigationInCharge, dragInCharge){
			var self = this;
			this.model.moveToOptions = {
				route:                      route,
				routeComponentID:           routeComponentID,
				windowIndex:                windowIndex,
				anchor:                     anchor,
				dragInCharge:               !!dragInCharge
			};

			// refresh environment if the column is present in order to get the columns and their windows up and running
			if(this.getColumn(route)){
				utils.refreshEnvironment(false, false, store, store.get(), self.model.master.onEnvironmentChanged, self.model.master, undefined, true, (Math.abs((window.orientation === undefined ? 90 : window.orientation) % 180) == 90));
			}
			else {
				// dynamic column loading
				this.performAction(this.prepareAction(this.model.loader.getLoadAction(route))).then(function(context){
					// add new column to internal list
					self.addColumn(context.action.source.load.component, anchor);

					// set anchor within newly added column component
					if(anchor) {
						context.action.source.load.component.model.properties.anchor = anchor;
					}

					// refresh environment to get the columns and their windows up and running
					utils.refreshEnvironment(false, false, store, store.get(), self.model.master.onEnvironmentChanged, self.model.master, undefined, true, (Math.abs((window.orientation === undefined ? 90 : window.orientation) % 180) == 90));
				});
			}
		},

		/**
		 * navigate back according to actual route
		 */
		back: function(){
			var route;
			var breadCrumbs = ((this.model.routes || {})[this.model.activeRoute || ''] || {}).breadCrumbs || [];

			if(utils.collectionSize(breadCrumbs) > 0 && (route = (breadCrumbs[breadCrumbs.length - 2] || {}).path)){
				var routeParts = route.split('#');
				if(routeParts.length > 1){
					if(routeParts.length == 2){
						this.to(routeParts[0], undefined, routeParts[1]);
					}
					else {
						console.error('invalid route parts detected');
					}
				}
				else {
					this.to(route);
				}
			}
		},

		/**
		 * this function will be called if all windows of a column are ready.
		 */
		onColumnUpdate: function(){
			// perform grid update only if all columns are ready
			this.model.columnUpdates++;
			if(this.model.columnUpdates < this.model.columns.length) return;
			this.model.columnUpdates = 0;

			// refresh additional style
			this.switchAdditionalStyle();

			// update grid dimensions
			this.updateGridDimensions();
		},

		/**
		 * (re)-calculate grid according to the actual environment, additionalStyles, ...
		 */
		updateGridDimensions: function(){

			// init checks
			var environment = this.activeEnvironment;
			if(!environment.dimensions) return false;

			// calculate base dimensions
			this.model.headPanelDimensions = {
				width:  environment.dimensions.window.width,
				height: parseInt(this.model.headPanel.$.outerHeight())
			};
			this.model.backButtonDimensions = {
				width:  parseInt(this.model.backButton.$.outerWidth()),
				height: environment.dimensions.window.height - this.model.headPanelDimensions.height
			};
			this.model.topNavBarDimensions = {
				width:  parseInt(this.model.topNavBar.$.outerWidth()),
				height: parseInt(this.model.topNavBar.$.outerHeight())
			};
			this.model.gridDimensions = {
				x:      0,
				y:      0,
				width:  environment.dimensions.window.width,
				height: environment.dimensions.window.height
			};
			
			// calculate final grid dimensions according to the actual additionalStyle
			if(this.model.additionalStyles.indexOf('topNavBar') > -1){
				if(this.model.additionalStyles.indexOf('fullHeight') === -1){
					this.model.gridDimensions.y         += this.model.topNavBarDimensions.height;
					this.model.gridDimensions.height    -= this.model.topNavBarDimensions.height;
				}
			}
			if(this.model.additionalStyles.indexOf('columnMenu') > -1){
				if(this.model.additionalStyles.indexOf('fullHeight') === -1){
					this.model.gridDimensions.y         += this.model.headPanelDimensions.height;
					this.model.gridDimensions.height    -= this.model.headPanelDimensions.height;
				}
			}
			else if(this.model.additionalStyles.indexOf('backButton') > -1){
				this.model.gridDimensions.x         += this.model.backButtonDimensions.width;
				this.model.gridDimensions.width     -= this.model.backButtonDimensions.width;

				if(this.model.additionalStyles.indexOf('fullHeight') === -1){
					this.model.gridDimensions.y         += this.model.headPanelDimensions.height;
					this.model.gridDimensions.height    -= this.model.headPanelDimensions.height;
				}
			}

			this.$.find('.grid').height(this.model.gridDimensions.height);

			// tell all columns that the gridDimensions has been updated
			if(this.model.columns.length > 0){
				for(var c in this.model.columns){
					this.model.columns[c].onGridUpdate(this.model.gridDimensions);
				}

				// tell all external registered components that the gridDimensions has been updated
				if(this.model.gridDependentRegister.length > 0){
					for(var c in this.model.gridDependentRegister){
						if((componentIndex = this.model.gridDependentRegister[c]) && (component = getComponent(componentIndex)) && typeof(component.onGridUpdate) === 'function'){
							component.onGridUpdate(this.model.gridDimensions);
						}
					}
				}

				// if everything is up to date - perform actual move
				this.moveTo();
			}

			var fullScreenGallery = getComponent('fullScreenGallery');
			if(fullScreenGallery){
				fullScreenGallery.onGridUpdate(this.model.gridDimensions);
			}
		},



		///////////////////////////////////
		/// TRANSITION HANDLING
		///////////////////////////////////

		/**
		 * this function is used to perform a scroll-down-transition by one window.
		 */
		scrollDown: function(){
			var column, windowProperties;
			if((column = this.getColumn()) && (windowProperties = column.getWindowProperties())){
				if(windowProperties.nextIndex !== false){
					column.scrollTo(windowProperties.nextIndex, undefined, windowProperties);
				}
				else {
					column.bump(false);
				}
			}
		},

		/**
		 * this function is used to perform a scroll-up-transition by one window.
		 */
		scrollUp: function(){
			var column, windowProperties;
			if((column = this.getColumn()) && (windowProperties = column.getWindowProperties())){
				if(windowProperties.prevIndex !== false){
					column.scrollTo(windowProperties.prevIndex, undefined, windowProperties);
				}
				else {
					column.bump(true);
				}
			}
		},

		/**
		 * this function is used to perform a non-scroll transition like slide or opacity-change.
		 *
		 * @param actualColumn              Component - actual column-component
		 * @param column                    Component - target column-component
		 * @param columnTransition          {} - transitionOptions
		 * @param callback                  function - optional - on transition done callback function
		 * @param onOverwriteCallback       function - optional - on transition overwritten callback function
		 *                                  NOTE: this function will be called when another tranition stops / overwrites the running one.
		 */
		transitionTo: function(actualColumn, column, columnTransition, callback, onOverwriteCallback){
			if(columnTransition.type === 'slide'){
				if(column.model.properties.previous){
					var slideOptions = {
						ease:   this.config.columnTransitions.slide.ease,
						x:      actualColumn.model.properties.gridDimensions.width
					};
					if(typeof(callback) === 'function'){
						slideOptions.onComplete = callback;
					}
					if(typeof(onOverwriteCallback) === 'function'){
						slideOptions.onOverwrite = onOverwriteCallback;
					}
					TweenMax.to(
						actualColumn.$,
						this.config.columnTransitions.slide.duration,
						slideOptions
					)
				}
				else if(column.model.properties.next){
					var slideOptions = {
						ease:   this.config.columnTransitions.slide.ease,
						x:      0
					};
					if(typeof(callback) === 'function'){
						slideOptions.onComplete = callback;
					}
					if(typeof(onOverwriteCallback) === 'function'){
						slideOptions.onOverwrite = onOverwriteCallback;
					}
					TweenMax.to(
						column.$,
						this.config.columnTransitions.slide.duration,
						slideOptions
					)
				}
			}
			else if(columnTransition.type === 'opacity'){
				if(column.model.properties.previous){
					var slideOptions = {
						ease:       this.config.columnTransitions.opacity.ease,
						opacity:    0
					};
					if(typeof(callback) === 'function'){
						slideOptions.onComplete = callback;
					}
					if(typeof(onOverwriteCallback) === 'function'){
						slideOptions.onOverwrite = onOverwriteCallback;
					}
					TweenMax.to(
						actualColumn.$,
						this.config.columnTransitions.opacity.duration,
						slideOptions
					)
				}
				else if(column.model.properties.next){
					var slideOptions = {
						ease:       this.config.columnTransitions.opacity.ease,
						opacity:    1
					};
					if(typeof(callback) === 'function'){
						slideOptions.onComplete = callback;
					}
					if(typeof(onOverwriteCallback) === 'function'){
						slideOptions.onOverwrite = onOverwriteCallback;
					}
					TweenMax.to(
						column.$,
						this.config.columnTransitions.opacity.duration,
						slideOptions
					)
				}
			}
			else {
				console.error('unknown column transition found');
			}
		},

		/**
		 * this function is used to perform a move-transition.
		 * NOTE: this may be a scroll, slide, opacity change or a combination of these transitions.
		 */
		moveTo: function(){
			var self = this;

			// is it necessary to perform a move?
			if(this.model.moveToOptions){
				var route                       = this.model.moveToOptions.route;
				var routeComponentID            = this.model.moveToOptions.routeComponentID;
				var anchor                      = this.model.moveToOptions.anchor;
				var windowIndex                 = this.model.moveToOptions.windowIndex;
				var initialMove                 = this.model.moveToOptions.initial;
				var dragInCharge                = this.model.moveToOptions.dragInCharge;
				var refresh                     = this.model.refreshNextMove;
				this.model.refreshNextMove      = false;
				this.model.moveToOptions        = {};
				var column, windowProperties;

				if((column = this.getColumn(route)) && (windowProperties = column.getWindowProperties(routeComponentID, anchor, windowIndex))){
					var actualColumn        = this.getColumn();
					var newRoute            = column.model.properties.route;
					var actualRoute         = actualColumn.model.properties.route;
					var columnTransition    = {
						type:       '',
						direction:  ''
					};
					var partIndex;

					// define transition-type and -direction
					if(newRoute != actualRoute){
						// new route is parent of actual route
						if((partIndex = this.model.routes[actualRoute].routes.indexOf(newRoute)) >= 0){
							columnTransition.type = 'slide';
							columnTransition.direction = 'previous';
						}
						// actual route is parent of new route
						else if((partIndex = this.model.routes[newRoute].routes.indexOf(actualRoute)) >= 0){
							columnTransition.type = 'slide';
							columnTransition.direction = 'next';
						}
						else {
							columnTransition.type = 'opacity';
							columnTransition.direction = 'next';
						}
					}

					// don't leaf column => scroll only to target window
					if(!columnTransition.type){

						// TODO: scrollTo for this.model.endlessScroll == true??

						column.scrollTo(windowProperties.index, windowProperties.usedAnchor, windowProperties, false, initialMove, this.model.styleChanged, dragInCharge, refresh);
						self.model.browserNavigationInCharge = false;
					}
					// perform column-transition and scroll to target window afterwards
					else {

						// TODO: scrollTo for this.model.endlessScroll == true??

						column.scrollTo(windowProperties.index, windowProperties.usedAnchor, windowProperties, true, undefined, undefined, dragInCharge, true);
						column.setState(columnTransition.direction, columnTransition.type, actualColumn);
						self.model.headPanel.morph(column, windowProperties.windowRouteComponentID, column.model.properties.route, windowProperties.usedAnchor ? '#' + windowProperties.usedAnchor : '');
						self.changeRouteProperties(column);
						this.transitionTo(actualColumn, column, columnTransition, function(){
							self.model.activeRoute      	= column.model.properties.route;
							self.model.activeRouteID    	= column.model.properties.routeID;
							self.model.activeRouteConfig  	= column.model.properties.routeConfig || {};
							actualColumn.setState();
							column.setState('actual');
							self.model.browserNavigationInCharge = false;
						});
					}
				}
			}
			// refresh head-panel if necessary even if no movement is necessary
			else if((column = this.getColumn()) && (windowProperties = column.getWindowProperties())){
				// this.refreshHead();
				this.model.headPanel.morph(column, windowProperties.windowRouteComponentID, column.model.properties.route, column.model.properties.anchor ? '#' + column.model.properties.anchor : '');
			}

			self.model.browserNavigationInCharge = false;
		}

	},

	hooks: {
		attach: function($element, options){
			if(!options.refresh){
				var self = this;
				var loadAnchor = decodeURIComponent(window.location.hash.replace(/^#/, ''));
				var routeModel;

				// set options needed for initial navigation
				this.model.moveToOptions = {
					route:      String(window.location.pathname || '').replace(/\/+$/, ''),
					anchor:     loadAnchor,
					initial:    true
				};

				// set shortcuts for often used child-components
				self.closest('base_master_master', function(masterComponent){
					self.model.master = masterComponent;
				});

				// estimate active route
				this.closest('base_master_master', function(masterComponent){
					self.model.activeRoute      = masterComponent.model.route;
					self.model.activeRouteID    = masterComponent.model.routeID;
					routeModel                  = masterComponent.model;
					routeModel.breadCrumbs		= window.storage.request.breadCrumbs || [];
				});
				// estimate and add column
				this.find('layouts_column_column', function(columnComponent){
					columnComponent.model.properties.routeID    	= self.model.activeRouteID;
					columnComponent.model.properties.route      	= self.model.activeRoute;
					columnComponent.model.properties.routeConfig  	= self.model.activeRouteConfig || {};
					self.addColumn(columnComponent, loadAnchor, routeModel);
				});

				// set shortcuts for often used child-components
				self.closest('layouts_master_master', function(masterComponent){
					self.model.master = masterComponent;
				});
				self.find('templates_loader_loader', function(loaderComponent){
					self.model.loader = loaderComponent;
				});
				self.find('templates_headPanel_headPanel', function(headPanelComponent){
					self.model.headPanel = headPanelComponent;
				});
				self.find('templates_topNavBar_topNavBar', function(topNavBarComponent){
					self.model.topNavBar = topNavBarComponent;
				});
				self.find('templates_headPanel_backButton', function(backButtonComponent){
					self.model.backButton = backButtonComponent;
				});

				// bind global events
				// $(window)
				// 	.off('mousewheel DOMMouseScroll', { component: self }, this.onScroll)
				// 	.on('mousewheel DOMMouseScroll', { component: self }, this.onScroll)
				// ;
				// this.$
				// 	.off('mousewheel DOMMouseScroll', { component: self }, this.onScroll)
				// 	.on('mousewheel DOMMouseScroll', { component: self }, this.onScroll)
				// ;

				// SAFARI ON TOUCHABLE DEVICES 3D EFFECT DRAG PROBLEM FIX
				window.ontouchmove = function(event){
					event.preventDefault();
				};

				// BROWSER NAVIGATION EVENTS
				window.onpopstate = function(){
					self.model.browserNavigationInCharge = true;
					self.to(window.location.pathname, undefined, window.location.hash.replace(/^#/, ''), undefined, true);
				};
			}
		}
	}
};
